import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateQuestionResponse } from "../actions/form";
import { ESRState } from "../types/data";
import {useParams} from "react-router-dom";

export function useRemoteField(
	resp_id: string,
	initial: string = "",
): [string, (v: string, pending?: boolean) => void, (v: string) => void, string, string] {
	const { esrId = "", activeId = "" } = useParams();

	const dispatch = useDispatch();

	const responses = useSelector((state: ESRState) => state.responses);
	const remoteValue = useSelector<ESRState, string>(
		(state) => state.responses[resp_id]?.response ?? initial,
	);
	const timestamp = useSelector<ESRState, string>(
		(state) => state.responses[resp_id]?.timestamp ?? "",
	);
	const responderId = useSelector<ESRState, string>(
		(state) => state.responses[resp_id]?.responder_id ?? "",
	);
	const [localValue, setLocalValue] = useState(initial);

	useEffect(() => {
		if (remoteValue !== localValue) {
			setLocalValue(remoteValue);
		}
		if (remoteValue.length > 0 && !(resp_id in responses)) {
			dispatch(updateQuestionResponse(esrId, activeId, resp_id, remoteValue));
		}
	}, [remoteValue]);

	const setRemoteValue = (newInputValue: string, pending: boolean = false) => {
		setLocalValue(newInputValue);
		dispatch(updateQuestionResponse(esrId, activeId, resp_id, newInputValue, undefined, "single", pending));
	};

	return [localValue, setRemoteValue, setLocalValue, timestamp, responderId];
}
